import React__default, { useState, useRef } from 'react';
import Popover from 'wix-rich-content-common/libs/Popover';
import { s as styleInject } from '../style-inject.es-746bb8ed.js';
import InfoIcon$1 from '../Icons/InfoIcon.js';

var css_248z = ".ceD4F{display:flex;height:max-content;width:max-content}";
var styles = {"popover_wrapper":"ceD4F"};
styleInject(css_248z);

const InfoIconWithPopover = ({ forceVisibility = false, children, langDir }) => /* @__PURE__ */ React__default.createElement(PopoverWrapper, null, ({ showTooltip, hideTooltip, active, parent }) => /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(InfoIcon$1, { onMouseEnter: showTooltip, onMouseLeave: hideTooltip }), /* @__PURE__ */ React__default.createElement(Popover, { active: forceVisibility || active, parent, langDir }, children)));
const PopoverWrapper = ({ children }) => {
  const [active, setActive] = useState(false);
  const showTooltip = () => setActive(true);
  const hideTooltip = () => setActive(false);
  const popoverParentRef = useRef(null);
  const parent = popoverParentRef == null ? void 0 : popoverParentRef.current;
  return /* @__PURE__ */ React__default.createElement("div", { className: styles.popover_wrapper, ref: popoverParentRef }, children({ active, showTooltip, hideTooltip, parent }));
};

export { InfoIconWithPopover as default };
//# sourceMappingURL=InfoIconWithPopover.js.map
